import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { BackButton, Button, Grid, TextInput } from '@labsavvyapp/components'
import { useOrdersetSettingsPageBusinessLogic } from '../../../logic/context'
import { OrdersetCategory } from './components'
import { v4 as uuidv4 } from 'uuid'
import { CategoryPanel, PackageCategoryPanel } from '../../../types'
import formatterPrice from '../../../../../../utils/formatter-price'

const ComponentLayout = styled.div`
  display: flex;
  flex-flow: column nowrap;
  margin: 15px;
  width: 100%;
`

export const CreateOrderset: React.FC = () => {
  const pageLogic = useOrdersetSettingsPageBusinessLogic()
  const createOrdersetForm = pageLogic?.createOrdersetForm ?? null
  const defaultCategoryData = pageLogic?.defaultCategoryData ?? null
  const defaultCategoryDataId = defaultCategoryData?.configs[0]?.value ?? '61ddcd93e87bef00179db0c4'
  const totalCreateOrdersetClientPrice = pageLogic?.totalCreateOrdersetClientPrice ?? 0
  const totalCreateOrdersetPatientPrice = pageLogic?.totalCreateOrdersetPatientPrice ?? 0

  const [packageCategoryPanels, setPackageCategoryPanels] = useState<PackageCategoryPanel[]>([])

  useEffect(() => {
    createOrdersetForm.setFieldValue(
      'categories',
      packageCategoryPanels.map((category) => ({
        category_id: category.category_id,
        panels: category.panels,
      })),
    )
  }, [packageCategoryPanels])

  const handleBackToOrdersetListPageClick = () => {
    pageLogic?.goToOrdersetListPage()
  }

  const handleAddNewCategoryClick = () => {
    setPackageCategoryPanels([
      ...packageCategoryPanels,
      {
        id: uuidv4(),
        category_id: defaultCategoryDataId,
        panels: [] as CategoryPanel[],
      },
    ])
  }

  return (
    <ComponentLayout>
      <BackButton onClick={handleBackToOrdersetListPageClick} text="Back to Orderset List" />
      <h1>Create Orderset</h1>
      <Grid mt={15}>
        <Grid.Col md={12} lg={4}>
          <TextInput label="Orderset Name" placeholder="Orderset Name" withAsterisk {...createOrdersetForm.getInputProps('name')} />
        </Grid.Col>

        {packageCategoryPanels.length < 1 && (
          <Grid.Col md={4} lg={2} mt={35}>
            <Button radius="xl" size="md" uppercase variant="outline" onClick={handleAddNewCategoryClick}>
              Start Adding Tests
            </Button>
          </Grid.Col>
        )}

        {packageCategoryPanels.length > 0 && (
          <Grid.Col md={12} lg={4}>
            <TextInput label="Orderset Client Bill" type="number" value={totalCreateOrdersetClientPrice?.toFixed(2)} icon={'$'} />
          </Grid.Col>
        )}

        {packageCategoryPanels.length > 0 && (
          <Grid.Col md={12} lg={4}>
            <TextInput label="Orderset Patient Bill" type="number" value={totalCreateOrdersetPatientPrice?.toFixed(2)} icon={'$'} />
          </Grid.Col>
        )}

        <Grid.Col lg={12}>
          {packageCategoryPanels.map((packageCategoryPanel) => (
            <OrdersetCategory category={packageCategoryPanel} key={packageCategoryPanel.id} handleOrdersetCategoryChange={setPackageCategoryPanels} />
          ))}
        </Grid.Col>
      </Grid>
    </ComponentLayout>
  )
}
